/**
 * Key Event Parser - Parse firmware key monitor output
 * Handles lines like: [123] PRESS q=2 r=3 vel=100
 *                      [123] PRESS q=2 r=3 note=56 ch=1 vel=100
 *                      [456] RELEASE q=2 r=3
 *                      [789] AT q=2 r=3 prs=80
 */

export interface ParsedKeyEvent {
  type: 'press' | 'release' | 'aftertouch';
  q: number;
  r: number;
  velocity?: number | undefined;
  pressure?: number | undefined;
}

// Match event type and q,r coordinates (required fields)
const MAIN_RE = /\[\d+\]\s+(PRESS|RELEASE|AT)\s+(?:.*?\s+)?q=(-?\d+)\s+r=(-?\d+)/;

// Extract vel= and prs= from anywhere in the line
const VEL_RE = /\bvel=(\d+)/;
const PRS_RE = /\bprs=(\d+)/;

export function parseKeyEvent(line: string): ParsedKeyEvent | null {
  const main = MAIN_RE.exec(line);
  if (!main) return null;

  const typeStr = main[1];
  const type = typeStr === 'PRESS' ? 'press' : typeStr === 'RELEASE' ? 'release' : 'aftertouch';

  const velMatch = VEL_RE.exec(line);
  const prsMatch = PRS_RE.exec(line);

  return {
    type,
    q: parseInt(main[2] ?? '0', 10),
    r: parseInt(main[3] ?? '0', 10),
    velocity: velMatch ? parseInt(velMatch[1] ?? '0', 10) : undefined,
    pressure: prsMatch ? parseInt(prsMatch[1] ?? '0', 10) : undefined,
  };
}
